import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { getFavouriteProducts } from 'Queries'
import { FavouriteCard, OosProducts } from './components'

const Favourites = ({ className, uuids, removeFavourite, screenType }) => {
  const GET_FAVOURITE_PRODUCTS = getFavouriteProducts(uuids)
  const { data, loading, error } = useQuery(GET_FAVOURITE_PRODUCTS, {
    errorPolicy: 'all'
  })
  if (loading) return <Loading className={className} />

  const products = []
  Object.keys(data).forEach(product => {
    if (data[product]) {
      products.push(data[product])
    }
  })
  const apiProducts = products.map(p => p.uuid)
  const oosProducts = uuids.filter(id => !apiProducts.includes(id))

  return (
    <div className={`main-container  ${className}`}>
      <div className="favourites__content">
        <h1 className="favourites__heading">Your Favourites</h1>
        {products.map((product, index) => (
          <FavouriteCard
            key={`${product.uuid}-${index}`}
            removeFavourite={removeFavourite}
            product={product}
          />
        ))}
        {oosProducts.length > 0 && (
          <OosProducts
            screenType={screenType}
            className={className}
            uuids={oosProducts}
            removeFavourite={removeFavourite}
          />
        )}
      </div>
    </div>
  )
}

export const Loading = ({ className }) => (
  <div className={`${className} favourites-loading`}>
    <div className="favourites__content">
      <div className="heading--loading"></div>
      <div className="favourite card--loading">
        <div className="favourite__imagewrapper"></div>
        <div className="loading__content"></div>
        <div className="loading-content-sub"></div>
      </div>
      <div className="favourite card--loading">
        <div className="favourite__imagewrapper"></div>
        <div className="loading__content"></div>
        <div className="loading-content-sub"></div>
      </div>
      <div className="favourite card--loading">
        <div className="favourite__imagewrapper"></div>
        <div className="loading__content"></div>
        <div className="loading-content-sub"></div>
      </div>
      <div className="favourite card--loading">
        <div className="favourite__imagewrapper"></div>
        <div className="loading__content"></div>
        <div className="loading-content-sub"></div>
      </div>
    </div>
  </div>
)

Loading.propTypes = {
  className: PropTypes.string
}

Favourites.propTypes = {
  className: PropTypes.string,
  uuids: PropTypes.array,
  removeFavourite: PropTypes.func,
  screenType: PropTypes.string
}

export default Favourites
